import { all, call, put, takeLatest } from '@redux-saga/core/effects';
import {
  CRM_EVENT,
  CRM_SAVE_EXIT_EVENT,
} from '../actions/crmEvent/crmEventActionConstants';
import {
  postCrmEvent,
  postSaveNExitCrmEvent,
} from '../../request/crmEventRequest';
import {
  postCrmEventSuccess,
  postSaveNExitSuccess,
} from '../actions/crmEvent/crmEventActions';

function* executeCrmEvent({ payload }) {
  try {
    const { data } = yield call(
      postCrmEvent,
      payload.applicationUid,
      payload.data,
    );
    yield put(postCrmEventSuccess(data));
    if (payload.onSuccess) {
      yield call(payload.onSuccess, data);
    }
  } catch (error) {
    if (payload?.onError) {
      yield call(payload.onError, error);
    }
  } finally {
    if (payload?.isLoading) {
      yield call(payload.isLoading, false);
    }
    if (payload?.onConfirm) {
      yield call(payload.onConfirm);
    }
  }
}

function* executeSaveExitCrmEvent({ payload }) {
  try {
    const { data } = yield call(
      postSaveNExitCrmEvent,
      payload.applicationUid,
      payload.data,
    );
    yield put(postSaveNExitSuccess(data));
    if (payload.onSuccess) {
      yield call(payload.onSuccess, data);
    }
  } catch (error) {
    if (payload?.onError) {
      yield call(payload.onError, error);
    }
  } finally {
    if (payload?.isLoading) {
      yield call(payload.isLoading, false);
    }
    if (payload?.onConfirm) {
      yield call(payload.onConfirm);
    }
  }
}

export default function* crmEventsSaga() {
  yield all([takeLatest(CRM_EVENT, executeCrmEvent)]);
  yield all([takeLatest(CRM_SAVE_EXIT_EVENT, executeSaveExitCrmEvent)]);
}
